/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { Box, Image, Link, Text } from '@chakra-ui/react';
import Slider from 'react-slick';

/* Internal Imports */
/* Components */
/* Services */

/* Styles */
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

/**
 * Renders the About Container component
 *
 * @param sectionData.sectionData
 * @param {object} sectionData - data
 * @returns {ReactElement} About Container component
 */
const AboutContainer = ({ sectionData }) => {
  const [isShowImageGallery, setIsShowImageGallery] = useState(false);
  const [ImageGallery, setImageGallery] = useState([]);
  const settings = {
    dots: true,
    autoplay: true,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,

    customPaging: function (i) {
      return (
        <Text
          cursor="pointer"
          display="inline-block"
          w="19px"
          h="19px"
          bgColor="#fff"
          borderRadius="50%"
          // className="bullet"
        ></Text>
      );
    },
    // dotsClass: "slick-dots about-dots",
  };

  const showImageGalleryHandler = images => {
    setIsShowImageGallery(true);
    setImageGallery([...images]);
  };

  return <>
    {sectionData.map((data, index) => {
      return (
        <Box
          key={index}
          p={{
            base: '20px 16px',
            sm: '20px 18px',
            md: '20px 18px 20px',
            lg: '40px 5px 70px 195px',
            xl: '40px 85px 70px',
          }}
          display={{ md: 'flex', sm: 'flex', base: 'flex' }}
          flexDirection={{
            md: `${index % 2 === 0 ? 'row' : 'row-reverse'}`,
            lg: 'column',
            xl: 'row',
          }}
          flexWrap={{ lg: 'nowrap', md: 'wrap', sm: 'wrap', base: 'wrap' }}
          mt={{
            base: '0',
            sm: '0',
            md: '0',
            lg: '50px',
          }}
          justifyContent="space-between"
        >
          <Box
            w={{
              sm: '100%',
              md: '100%',
              base: '100%',
              lg: '99%',
              xl: '50%',
            }}
            pl={{
              md: `${index % 2 === 0 ? '195px' : ''}`,
              lg: `${index % 2 === 0 ? '35px' : '0'}`,
            }}
            pr={{
              md: `${index % 2 === 0 ? '' : '195px'}`,
              lg: 0
            }}
          >
            <Box
              boxShadow="0 22px 30px -10px rgb(0 0 0 / 40%)"
              w={{ base: '100%', sm: '100%', md: '100%', lg: '500px' }}
            >
              <Slider
                float="left"
                w={{ base: '100%', sm: '100%', md: '100%' }}
                mr="70px"
                ml={{ base: '0', sm: '0', md: '30px' }}
                // className={classes["about-img-slot"]}
                {...settings}
              >
                {data.images.map((img, i) => {
                  return (
                    <Box key={i} {...settings}>
                      <Image
                        alt={img.alt}
                        title={img.title}
                        width={{ md: '100%' }}
                        src={img.url}
                        onClick={() => {
                          showImageGalleryHandler(data.images);
                        }}
                      />
                    </Box>
                  );
                })}
              </Slider>
            </Box>
          </Box>
          <Box
            mt={{ base: '34px', xl: '0' }}
            pl={{
              md: `${index % 2 === 0 ? '195px' : ''}`,
              lg: '35px',
              xl: `75px`,
            }}
            pr={{
              md: `${index % 2 === 0 ? '' : '195px'}`,
              xl: `75px`,
            }}
          >
            <Box
              paddingBottom={data.title === 'Dedicated' ? '25px' : ''}
              mt={data.title === 'Dedicated' ? '20px' : ''}
              lineHeight={data.title === 'Dedicated' ? '1.4' : ''}
              fontWeight={data.title === 'Dedicated' ? '500' : ''}
              fontSize={data.title === 'Dedicated' ? '20px' : '16px'}
              fontFamily={'Fedra-Light,sans-serif'}
            >
              <Text
                as={data.title === 'Dedicated' ? 'span' : ''}
                fontSize="40px"
                color="#28231e"
                mb="10px"
                fontFamily="FedraSansStd-A-medium,sans-serif"
                lineHeight={{ base: '1', lg: '1.3' }}
              >
                {data.title}
              </Text>
              <Text
                pl={data.title === 'Dedicated' ? '10px' : ''}
                as={data.title === 'Dedicated' ? 'span' : ''}
                fontSize="16px"
                mt="20px"
                fontFamily="Fedra-Light,sans-serif"
                lineHeight="1.5"
                color="#000"
                textAlign="left"
                mb="25px"
              >
                {data.body.replace(/<[^>]*>/g, '')}
              </Text>
            </Box>
            <Box>
              <Link
                p={{ base: '10px', lg: '6px' }}
                pt={{ base: '12px' }}
                h="32px"
                fs="13px"
                w={{ base: '142px', lg: '168px' }}
                color="#cf4520"
                border="1px solid #cf4520"
                borderRadius="4px"
                fontFamily="FedraSansStd-medium,sans-serif"
                fontSize="16px"
                href={data.pressLink && data.pressLink.url}
                textDecoration="none !important"
                isExternal
              >
                Download Press kit
              </Link>
            </Box>
          </Box>
          <style jsx global>{`
            .slick-dots {
              bottom: 5px;
            }
            .slick-dots li.slick-active p {
              background-color: #f5ac3e;
            }
          `}</style>
        </Box>
      );
    })}
  </>;
};

export default AboutContainer;
